import { render, staticRenderFns } from "./TournamensCarousel.vue?vue&type=template&id=e58c6398&scoped=true"
import script from "./TournamensCarousel.vue?vue&type=script&lang=js"
export * from "./TournamensCarousel.vue?vue&type=script&lang=js"
import style0 from "./TournamensCarousel.vue?vue&type=style&index=0&id=e58c6398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58c6398",
  null
  
)

export default component.exports